<template>
    <div class="profile-wrap col-md-8 mx-auto border rounded px-2 py-2">
        <div class="title-wrap border-bottom mb-3">
            <h1>{{$ml.with('VueJS').get('Profile')}}</h1>
        </div>
        <div class="w-100 form-wrap">
            <b-form>
                <b-form-group id="input-name" :label="`${$ml.with('VueJS').get('FullName')}:`" label-for="name" class="text-left">
                    <b-form-input
                            id="name"
                            v-model="form.name"
                            placeholder=""
                    ></b-form-input>
                </b-form-group>

                <b-form-group id="input-email" :label="`${$ml.with('VueJS').get('Email')}:`" label-for="email" class="text-left">
                    <b-form-input
                            id="email"
                            v-model="form.email"
                            type="email"
                            placeholder=""
                    ></b-form-input>
                </b-form-group>
            </b-form>

            <b-button type="submit" variant="success" class="w-100" @click="updateProfile()">{{$ml.with('VueJS').get('Save')}}</b-button>
        </div>
    </div>
</template>

<style lang="scss">
    .profile-wrap {
        background-color: #f2f2f2;
    }
    .title-wrap h1 {
        line-height: 85px;
    }
</style>

<script>
  import mixinUtils from "@/components/mixinUtils";
  export default {
    name: 'profile',
    mixins: [mixinUtils],
    components: {
    },
    data: () => ({
      form: {
        name: null,
        email: null,
      }
    }),
    methods: {
      updateProfile () {
        const contex = this
        contex.apiCall('users/update-info', 'post', contex.form)
          .then(function (response) {
            if (response.data.status === 200) {
              contex.$bvToast.toast(`Данные успешно сохранены`, {
                title: 'Профиль',
                autoHideDelay: 5000,
                variant: 'success',
                appendToast: false,
                toaster: 'b-toaster-bottom-right',
              })
            }
          })
      }
    },
    mounted() {
      if (!this.$store.state.isAuthenticated()) {
        this.$router.push({path: '/login'})
      }

      this.form.name = this.$store.state.user.profile.name
      this.form.email = this.$store.state.user.email
      this.form.phone = this.$store.state.user.phone
    }
  }
</script>